import React, {Component} from 'react';
import PropTypes from 'prop-types';
import MyNavbar from '../components/MyNavbar.js';
import ShippingHandlingContent from '../components/ShippingHandlingContent.js';
import Connect from '../components/Connect.js';
import FooterHelp from '../components/FooterHelp.js';
import FooterBottom from '../components/FooterBottom.js';
import styled from 'styled-components';
import media from '../MediaQueries.js';

export default class ShippingHandling extends Component {

  constructor(props) {
    super(props);

    this.state = {
      ordersOpen: false,
      shippingOpen: false,
      returnsOpen: false,
      breakageOpen: false
    };
  }

  toggleOrders = () => {
    this.setState({
      ordersOpen: !this.state.ordersOpen
    });
  }

  toggleShipping = () => {
    this.setState({
      shippingOpen: !this.state.shippingOpen
    });
  }

  toggleReturns = () => {
    this.setState({
      returnsOpen: !this.state.returnsOpen
    });
  }

  toggleBreakage = () => {
    this.setState({
      breakageOpen: !this.state.breakageOpen
    });
  }

  render () {
  	return (
      <div>
        <ShippingHandlingContent toggleOrders={this.toggleOrders} toggleShipping={this.toggleShipping} 
          toggleReturns={this.toggleReturns} toggleBreakage={this.toggleBreakage} 
          ordersOpen={this.state.ordersOpen} shippingOpen={this.state.shippingOpen}
          returnsOpen={this.state.returnsOpen} breakageOpen={this.state.breakageOpen} />
      </div>
  	);
  }
}



// WEBPACK FOOTER //
// ./src/pages/ShippingHandling.js